import type React from 'react';
import { useEffect } from 'react';

import { FuturesProgressStep, type InstitutionFuturesProgressStep, useProgress } from '@/context/progress';
import BaseLayout from '@/layouts/base';

export type FuturesAppropriatenessTestLayoutProps = React.ComponentPropsWithoutRef<typeof BaseLayout> & {
  progress?: number;
  step?:
    | Extract<FuturesProgressStep, typeof FuturesProgressStep.APPROPRIATENESS_TEST>
    | Extract<InstitutionFuturesProgressStep, typeof InstitutionFuturesProgressStep.APPROPRIATENESS_TEST>;
};

const FuturesAppropriatenessTestLayout = ({ progress, step = FuturesProgressStep.APPROPRIATENESS_TEST, ...props }: FuturesAppropriatenessTestLayoutProps) => {
  const { setCurrentStep } = useProgress();

  useEffect(() => {
    return setCurrentStep(step, progress);
  }, [progress, setCurrentStep, step]);

  return <BaseLayout {...props} />;
};
FuturesAppropriatenessTestLayout.displayName = 'FuturesAppropriatenessTestLayout';

export default FuturesAppropriatenessTestLayout;
